import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '../core/service/auth/authentication.service';
import { CoreModule } from '../core/core.module';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { Router } from '@angular/router';
import { HomeCard } from 'app/models/home-card';
import { IconoirNavArrowLeft, IconoirNavArrowRight } from '@ey-xd/motif-icon';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment } from 'environments/environment';
import { ToastService } from 'app/core/service/toast/toast.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    CoreModule,
    MotifModule,
  ],
})
export class HomeComponent implements OnInit, AfterViewInit {
  //Icons
  IconoirNavArrowLeft = IconoirNavArrowLeft;
  IconoirNavArrowRight = IconoirNavArrowRight;

  @ViewChild('cardsContainer') cardsContainer!: ElementRef;

  showScrollLeft: boolean = false;
  showScrollRight: boolean = false;

  cards: HomeCard[] = [
    {
      agent: '',
      header: `Trial Balance Extraction and </br> UK Chart of Account Mapping`,
      content: `
        <p>
          Use the Trial Balance (TB) Extraction Agent to automatically extract data from a
          client's TB into a standardised format.
        </p>
        <p>
          Use the UK Chart of Account Mapping Agent to automatically map this standardised
          TB extract into EY's Tax Chart of Account.
        </p>
      `,
      action: () => this.goToAgentOneTwo(),
    },
    // {
    //   agent: 'Agent 4',
    //   header: 'Tax Questions Generation',
    //   content: `
    //     <p>
    //       This agent will generate questions for clients. Lorem ipsum dolor sit amet, consectetur
    //       adipiscing
    //       elit. Proin nulla lorem, tempor nec nibh placerat, vulputate laoreet quam. Integer nisl risus,
    //       pretium
    //       in ligula sed, bibendum tempor purus. Suspendisse vel ultrices risus. Donec luctus facilisis
    //       tristique.
    //       Quisque et metus risus. Duis vulputate diam a risus ornare scelerisque.
    //     </p>
    //   `,
    //   action: () => this.triggerAction(),
    // },
    {
      agent: '',
      header: 'Corporate Income Tax Review',
      content: `
        <p>Use the Corporate Income Tax Review Agent to:</p>
        </br>
        - Identify potentially tax sensitive issues noted in the Financial Statements
        </br>
        </br>
        - Compare the information in the Financial Statements with that in the computation and return
        </br>
        </br>
        - Compare the prior year and current year computations and returns
      `,
      action: () => this.goToAgentFive(),
    },
    {
      agent: '',
      header: 'iXBRL Agent',
      content: `
        <p>
          The iXBRL Agent enables document acceptance, document formatting and review of tagging.
        </p>
      `,
      action: () => this.goToIXBRL(),
    },
  ];

  isScrollable: boolean = this.cards.length > 2;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    protected authenticationService: AuthenticationService,
    protected router: Router,
    private breakpointObserver: BreakpointObserver,
    private toastService: ToastService
  ) {
    // NOTE: Predefined and 900px because thats the estimated max-width to trigger at 150% of zoom
    // when everything start to look off
    this.breakpointObserver
      .observe([Breakpoints.Handset, '(max-width: 900px)'])
      .subscribe((result) => {
        // result matches returns true if the width is <= 900px
        this.isZoomed = result.matches;
      });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.updateScrollButtons();
    this.cardsContainer.nativeElement.addEventListener('scroll', () => {
      this.updateScrollButtons();
    });
    this.toastService.clearToastWithTag(true);
  }

  goToAgentOneTwo(): void {
    this.router.navigate(['/tb-agent']);
  }

  goToAgentFive(): void {
    this.router.navigate(['/agent-five']);
  }

  goToIXBRL(): void {
    this.router.navigate(['/ixbrl']);
  }

  /**Scroll buttons function */
  scrollCards(direction: 'left' | 'right') {
    const scrollAmount = 300;
    const container = this.cardsContainer.nativeElement as HTMLElement;

    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }

    setTimeout(() => this.updateScrollButtons(), 300);
  }

  updateScrollButtons() {
    const container = this.cardsContainer.nativeElement as HTMLElement;
    const { scrollLeft, scrollWidth, clientWidth } = container;

    this.showScrollLeft = scrollLeft > 0 && this.isScrollable;
    this.showScrollRight =
      scrollLeft + clientWidth < scrollWidth - 1 && this.isScrollable;
  }
}
